import { useMutation } from '@apollo/client';
import { CREATE_PLOTS, DELETE_PLOTS, UPDATE_PLOTS } from 'graphql/secure/mutations/plot.mutations';
import {
  ICreatePlotsInput,
  IUpdatePlotInput,
} from 'graphql/secure/mutations/types/plots-muation.types';
import { IPlot } from 'FeatureModules/Site/types/plot.types';

const usePlotsMutations = () => {
  const [createPlots, { loading: createLoading }] = useMutation<
    { createPlots: { plots: IPlot[] } },
    { inputs: ICreatePlotsInput[] }
  >(CREATE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  const [updatePlots, { loading: updateLoading }] = useMutation<
    { createPlots: { plots: IPlot[] } },
    { inputs: IUpdatePlotInput[] }
  >(UPDATE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  const [deletePlots, { loading: deleteLoading }] = useMutation<
    { deletePlots: { plots: { id: string }[] } },
    { ids: string[] }
  >(DELETE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  return {
    loading: createLoading || updateLoading || deleteLoading,
    createLoading,
    updateLoading,
    deleteLoading,
    createPlots,
    updatePlots,
    deletePlots,
  };
};

export default usePlotsMutations;
